import store from "../store";

export const hasPermission = (permissionSlug) => store.state.permissions.indexOf(permissionSlug) !== -1;

export const hasAnyPermission = (permissionSlugs) => {
    return permissionSlugs.some(permission => hasPermission(permission));
};

export const hasAllPermissions = (...permissionSlugs) => {
    const activePermissions = store.state.permissions;
    const permissionsToCheck = Array.isArray(permissionSlugs[0]) ? permissionSlugs[0] : permissionSlugs;
    return permissionsToCheck.every(permission => activePermissions.includes(permission));
};

export const hasLocationPermission = (locationTypeIdentifier, locationIdentifier, permissionSlug) => {
    if (!hasPermission(permissionSlug)) {
        return false
    }

    return hasLocation(locationTypeIdentifier, locationIdentifier)
};

export const hasAnyLocationPermission = (locationTypeIdentifier, locationIdentifier, permissionSlugs) => {
    if (!hasAnyPermission(permissionSlugs)) {
        return false
    }

    return hasLocation(locationTypeIdentifier, locationIdentifier)
};

export const hasLocation = (locationTypeIdentifier, locationIdentifier, ignoreCanManageAllPermission = false) => {
    if (!ignoreCanManageAllPermission && hasPermission('canmanagealllocations')) {
        return true
    }

    return store.state.locationsForUser.some(l => l.location_type.identifier === locationTypeIdentifier && l.identifier === locationIdentifier)
};

export const hasLocationId = (id) => {
    if (hasPermission('canmanagealllocations')) {
        return true
    }

    return store.state.locationsForUser.some(l => l.id === id)
};

export const getLocationForUserById = (id) => {
    return store.state.locationsForUser.find(l => l.id === id)
};

export const isFeatureEnabled = (featureIdentifier) => {
    return !!store.state.config.general['features-enabled'][featureIdentifier]
}

export const isAnyFeatureEnabled = (featureIdentifiers) => {
    for (let i in featureIdentifiers) {
        if (isFeatureEnabled(featureIdentifiers[i])) {
            return true
        }
    }

    return false
}

export default { hasPermission, hasAnyPermission }
